import TabbedPageShell from '@/components/TabbedPageShell';
import MyHomeTab from '@/components/home/MyHomeTab';
import HomeJourneyCard from '@/components/home/HomeJourneyCard';
import SectionNudge from '@/components/SectionNudge';
import HomeAdminTab from '@/components/home/HomeAdminTab';
import SectionGuideRail from '@/components/playbooks/SectionGuideRail';

const TABS = [
  {
    key: 'home',
    label: 'Home',
    subtitle: 'Tenancy, bills, vehicles, repairs, evidence, and moving tasks',
    content: (
      <div className="space-y-5">
        <MyHomeTab />
        <HomeAdminTab />
      </div>
    ),
  },
];

export default function HomePage() {
  return (
    <TabbedPageShell
      title="My Home"
      subtitle="Know what I have, what's coming up, and what to do"
      tabs={TABS}
      nudge={<SectionNudge section="home" />}
      hero={<HomeJourneyCard />}
      guideRail={<SectionGuideRail section="home" />}
    />
  );
}
